import { render, staticRenderFns } from "./couponIndex.vue?vue&type=template&id=7cde3462"
import script from "./couponIndex.vue?vue&type=script&lang=ts"
export * from "./couponIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports